export default __webpack_public_path__ + "static/media/source-logo-redshift.b9efb68f.png";